import { FC, useMemo } from 'react';
import { generalHelpers } from '@monorepo/helpers';
import { typeHTHTerritory, typeHTHFace, typePublicMinistryService } from '@monorepo/models';
import { useGetIsMobile } from 'src/custom-hooks';

type propsType = {
    service: typePublicMinistryService;
    tt: typeHTHTerritory;
};

export const HTHActivityFaceActivity: FC<propsType> = ({ service, tt }) => {

    const coveredPolygons = useMemo(() => tt.faces
        .filter(p => p.serviceDates.find(sd => sd.serviceId === service.id))
        .sort((p1, p2) =>
            ((p1.serviceDates!.find(sd => sd.serviceId === service.id)!.completionDate) - p1.serviceDates!.find(sd => sd.serviceId === service.id)!.completionDate)
            || (Number(p1.block) - Number(p2.block))
            || p1.street.localeCompare(p2.street)
        )
    , [service, tt]);

    return (
        <>
        {!!coveredPolygons.length ?
            coveredPolygons.map(p =>
                <Activity key={p.id}
                    polygon={p}
                    service={service}
                />
            )
            :
            <div className={'text-center small'}>
                (Sin actividad informada)
            </div>
        }
        </>
    );
}

type propsType1 = {
    polygon: typeHTHFace;
    service: typePublicMinistryService;
};

const Activity: FC<propsType1> = ({ polygon, service }) => {
    const activity = polygon.serviceDates.find(sd => sd.serviceId === service.id);
    const isMobile = useGetIsMobile();

    return (activity ?
        <div className={'d-flex justify-content-between'}>
            <div className={'ps-1'}>
                -Manzana {polygon.block}, {polygon.street}
            </div>
            <div className={isMobile ? 'pe-1' : ''}>
                {generalHelpers.FormatDate(new Date(activity.completionDate))}
            </div>
        </div>
        :
        <div>
            Sin actividad
        </div>
    );
}
